import { FinesRoleEnum } from '../../enums/fines-role/fines-role.enum';
import { UserInfo } from './user-info.model';

export const userInfo: UserInfo = {
    fine: '1234567890123456',
    roles: [FinesRoleEnum.TITULAR, FinesRoleEnum.IDENTIFICATION],
    subject: '1234567890123456',
};
